import React, { useState } from "react";
import Text from "../../common/Text";

export default function TermsConditionsPopup({ closePopup, content }) {
  return (
    <>
      <section className="popup invite_popups_all">
        <div className="tableDv">
          <div className="tableCell">
            <div className="_inner">
              <div className="crosBtn" onClick={closePopup}></div>
              <div className="textual_blk_terms ckEditor">
                <Text string={content} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
